var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { UserRole } from '../models/general.models';
import { useIsPlanPreferencesEnabled } from '../hooks/useIsPlanPreferencesEnabled';
import OnboardingStepGuard from './components/OnboardingStepGuard';
import RouteAuthorizer from './components/RouteAuthorizer';
import { AppRoutes } from './routes';
var onboardingRedirectPages = [
    {
        userRole: UserRole.Anonymous,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.NoCountryUser,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.CompleteUser,
        page: AppRoutes.Plan,
    },
    {
        userRole: UserRole.UserPaymentNeeded,
        page: AppRoutes.SubscriptionPage,
    },
    {
        userRole: UserRole.PlanPendingUser,
        page: AppRoutes.Plan,
    },
];
var onboardingDataStepBaseRoles = [
    UserRole.PartialUser,
    UserRole.AnonymousCouponRedeemUser,
];
var onboardingDataStepPlanPreferencesRoles = __spreadArray(__spreadArray([], onboardingDataStepBaseRoles, true), [
    UserRole.PlanPendingUser,
    UserRole.UserPaymentNeeded,
], false);
export var OnboardingDataStepAuthorizer = function (_a) {
    var children = _a.children;
    var isPlanPreferencesEnabled = useIsPlanPreferencesEnabled();
    return (_jsx(RouteAuthorizer, { userRoles: isPlanPreferencesEnabled
            ? onboardingDataStepPlanPreferencesRoles
            : onboardingDataStepBaseRoles, redirectPages: onboardingRedirectPages, children: children }));
};
var NamePage = React.lazy(function () { return import('../pages/onboarding/name.page'); });
var BirthdayPage = React.lazy(function () { return import('../pages/onboarding/birthday.page'); });
var GenderPage = React.lazy(function () { return import('../pages/onboarding/gender.page'); });
var HeightPage = React.lazy(function () { return import('../pages/onboarding/height.page'); });
var WorkoutPage = React.lazy(function () { return import('../pages/onboarding/workout.page'); });
var DietTypePage = React.lazy(function () { return import('../pages/onboarding/dietType.page'); });
var AllergiesPage = React.lazy(function () { return import('../pages/onboarding/allergies.page'); });
var JoinFamilyPage = React.lazy(function () { return import('../pages/onboarding/familyCode.page'); });
var DislikedIngredientsPage = React.lazy(function () { return import('../pages/onboarding/dislikedIngredients.page'); });
var PlanPreferencesPage = React.lazy(function () { return import('../pages/onboarding/planPreferences.page'); });
var WelcomePage = React.lazy(function () { return import('../pages/onboarding/welcome/welcome.page'); });
var ProfileDetailPage = React.lazy(function () { return import('../pages/onboarding/welcome/profileDetail.page'); });
var onboardingRoutes = [
    {
        path: AppRoutes.Base,
        element: _jsx(Navigate, { to: AppRoutes.Intro, replace: true }),
    },
    {
        path: AppRoutes.OnboardingName,
        element: (_jsx(OnboardingDataStepAuthorizer, { children: _jsx(OnboardingStepGuard, { step: AppRoutes.OnboardingName, children: _jsx(NamePage, {}) }) })),
    },
    {
        path: AppRoutes.OnboardingBirthday,
        element: (_jsx(OnboardingDataStepAuthorizer, { children: _jsx(OnboardingStepGuard, { step: AppRoutes.OnboardingBirthday, children: _jsx(BirthdayPage, {}) }) })),
    },
    {
        path: AppRoutes.OnboardingGender,
        element: (_jsx(OnboardingDataStepAuthorizer, { children: _jsx(OnboardingStepGuard, { step: AppRoutes.OnboardingGender, children: _jsx(GenderPage, {}) }) })),
    },
    {
        path: AppRoutes.OnboardingHeight,
        element: (_jsx(OnboardingDataStepAuthorizer, { children: _jsx(OnboardingStepGuard, { step: AppRoutes.OnboardingHeight, children: _jsx(HeightPage, {}) }) })),
    },
    {
        path: AppRoutes.OnboardingWorkout,
        element: (_jsx(OnboardingDataStepAuthorizer, { children: _jsx(OnboardingStepGuard, { step: AppRoutes.OnboardingWorkout, children: _jsx(WorkoutPage, {}) }) })),
    },
    {
        path: AppRoutes.OnboardingDietType,
        element: (_jsx(OnboardingDataStepAuthorizer, { children: _jsx(OnboardingStepGuard, { step: AppRoutes.OnboardingDietType, children: _jsx(DietTypePage, {}) }) })),
    },
    {
        path: AppRoutes.OnboardingAllergies,
        element: (_jsx(OnboardingDataStepAuthorizer, { children: _jsx(OnboardingStepGuard, { step: AppRoutes.OnboardingAllergies, children: _jsx(AllergiesPage, {}) }) })),
    },
    {
        path: AppRoutes.OnboardingDislikedIngredientsPage,
        element: (_jsx(OnboardingDataStepAuthorizer, { children: _jsx(OnboardingStepGuard, { step: AppRoutes.OnboardingDislikedIngredientsPage, children: _jsx(DislikedIngredientsPage, {}) }) })),
    },
    {
        path: AppRoutes.OnboardingPlanPreferences,
        element: (_jsx(RouteAuthorizer, { userRoles: [
                UserRole.PartialUser,
                UserRole.AnonymousCouponRedeemUser,
                UserRole.PlanPendingUser,
                UserRole.UserPaymentNeeded,
            ], redirectPages: onboardingRedirectPages, children: _jsx(OnboardingStepGuard, { step: AppRoutes.OnboardingPlanPreferences, children: _jsx(PlanPreferencesPage, {}) }) })),
    },
    {
        path: AppRoutes.OnboardingWelcomePage,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.PlanPendingUser], redirectPages: onboardingRedirectPages, children: _jsx(WelcomePage, {}) })),
    },
    {
        path: AppRoutes.JoinFamily,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.PartialUser], redirectPages: onboardingRedirectPages, children: _jsx(JoinFamilyPage, {}) })),
    },
    {
        path: "".concat(AppRoutes.OnboardingProfilePage, "/:id"),
        element: (_jsx(RouteAuthorizer, { userRoles: [
                UserRole.PlanPendingUser,
                UserRole.AnonymousCouponRedeemUser,
            ], redirectPages: onboardingRedirectPages, children: _jsx(ProfileDetailPage, {}) })),
    },
];
export default onboardingRoutes;
